import lazy from '../utility/lazy'
import { IRouteConfig } from '@fareye/types'
import TripDetailsRenderingConfig from './LayoutRenderingConfig/TripDetailsRenderingConfig'
import { ParcelDetails } from '@fareye/trip-details'
import { parcelConfig } from './LayoutRenderingConfig/ParcelDetailRenderingConfig'
import { Devices,ConsignerOnboarding, PoiConfig,DefaultPoiConfig, ChildUsers} from '@fareye/settings'
import { ConsignerOnboardRenderingConfig } from './LayoutRenderingConfig/ConsignerOnboardRenderingConfig'

const ConfigManagement = lazy(
  () => import('@fareye/jsonstore-ui'),
  'ConfigManagement'
)
const ReportsConfiguration = lazy(
  () => import('@fareye/jsonstore-ui'),
  'ReportsConfiguration'
)
const TablesConfiguration = lazy(
  () => import('@fareye/jsonstore-ui'),
  'TablesConfiguration'
)
const TripDetails = lazy(() => import('@fareye/trip-details'), 'TripDetails')
const MultiModelHistory = lazy(
  () => import('@fareye/trip-details'),
  'MultiModelHistory'
)
const InTransitMapPort = lazy(
  () => import('@fareye/intransit-map'),
  'InTransitMapPort'
)
const PublicTerminalView = lazy(
  () => import('@fareye/intransit'),
  'PublicTerminalView'
)
const HubsMapper = lazy(() => import('@fareye/intransit'), 'HubsMapper')

// Leave Label Empty If you don't want it in SideBar Item
// layout empty array if you don't want sidebar and header
// Do Not put sub routes inside children key if parent doesnot need submenu, keep subpaths on same level inside json

export const routesConfig: IRouteConfig[] = [
  //   {
  //     authenticated: false,
  //     bLabel: '',
  //     children: undefined,
  //     exact: true,
  //     key: 'login',
  //     label: '',
  //     layout: [],
  //     link: '/login',
  //     path: '/login'
  //   },
  //   {
  //     authenticated: true,
  //     bLabel: '',
  //     children: undefined,
  //     exact: true,
  //     key: 'parcelList',
  //     label: '',
  //     layout: ['header', 'sidebar'],
  //     link: '/',
  //     path: '/'
  //   },
  {
    authenticated: true,
    bLabel: 'Parcel Visibility',
    children: undefined,
    exact: true,
    key: 'parcelDetail',
    label: '',
    layout: ['header', 'sidebar'],
    link: '/track-parcel/:slug',
    path: '/track-parcel/:slug',
    subType: 'parcel',
    pageId: 'parcelDetail'
  },
  {
    authenticated: true,
    bLabel: 'Parcel Visibility',
    children: undefined,
    exact: true,
    key: 'parcelList',
    label: '',
    layout: ['header', 'sidebar'],
    link: '/',
    path: '/',
    subType: 'parcel',
    pageId: 'parcelList'
  },
  {
    authenticated: true,
    bLabel: 'Parcel',
    children: [
      {
        authenticated: true,
        bLabel: 'E.T.A',
        children: undefined,
        exact: true,
        key: 'parcelList',
        label: 'E.T.A',
        layout: ['header', 'sidebar'],
        link: '/parcel/eta',
        path: '/parcel/eta',
        subType: 'parcel',
        pageId: 'parcelList'
      },
      {
        authenticated: true,
        bLabel: 'Parcel Route Performance',
        children: undefined,
        exact: true,
        key: 'parcelRoutePerformance',
        label: 'InTransit Performance',
        layout: ['header', 'sidebar'],
        link: '/parcel/route',
        path: '/parcel/route',
        subType: 'parcel',
        pageId: 'parcelRoutePerformance'
      },
      {
        authenticated: true,
        bLabel: 'Parcel Carriers',
        children: undefined,
        exact: true,
        key: 'parcelCarrierPerformance',
        label: '',
        layout: ['header', 'sidebar'],
        link: '/parcel/carriers',
        path: '/parcel/carriers',
        subType: 'parcel',
        pageId: 'parcelCarrierPerformance'
      },
      {
        authenticated: true,
        bLabel: '',
        children: undefined,
        exact: true,
        key: 'parcelCarrierDetail',
        label: '',
        layout: ['header', 'sidebar'],
        link: '/parcel/carriers',
        path: '/parcel/carriers/:transporter',
        subType: 'parcel',
        pageId: 'parcelCarrierDetail'
      },
      {
        authenticated: true,
        bLabel: '',
        children: undefined,
        exact: true,
        key: 'parcelRouteDetail',
        label: '',
        layout: ['header', 'sidebar'],
        link: '/parcel/route',
        path: '/parcel/route/:route',
        subType: 'parcel',
        pageId: 'parcelRouteDetail'
      }
    ],
    exact: false,
    key: 'parcel',
    label: 'In-Transit',
    layout: ['header', 'sidebar'],
    link: '/parcel/eta',
    path: '/parcel/eta'
  },
  {
    authenticated: true,
    bLabel: 'KPI',
    children: undefined,
    exact: true,
    key: 'parcelKpi',
    label: 'KPI',
    layout: ['header', 'sidebar'],
    link: '/kpi',
    path: '/kpi',
    subType: 'parcelKpiConfig'
  },
  {
    authenticated: true,
    bLabel: 'Reports',
    children: undefined,
    exact: true,
    key: 'reportSettings',
    label: 'Reports',
    layout: ['header', 'sidebar'],
    link: '/report',
    path: '/report',
    subType: 'parcelReports'
  },
  {
    authenticated: true,
    bLabel: 'Reports',
    children: undefined,
    exact: true,
    key: 'reportSettings',
    label: 'Reports',
    layout: ['header', 'sidebar'],
    link: '/report',
    path: '/report',
    subType: 'parcelReports'
  },
  //   {
  //     authenticated: true,
  //     bLabel: 'In Plant Performance',
  //               children: [
  //               {
  //               authenticated: true,
  //         bLabel: 'In Plant path',
  //         children: undefined,
  //           exact: true,
  //           key: 'inplantPerformance',
  //         label: 'In Plant Performance',
  //         layout: ['header', 'sidebar'],
  //         link: '/in-plant',
  //                     path: '/in-plant',
  //                     subType: 'inplant',
  //                   pageId: 'inplantPerformance'
  //       },
  //       {
  //                 authenticated: true,
  //               bLabel: 'In Plant Map',
  //               children: undefined,
  //         exact: true,
  //         key: 'inplantMap',
  //         label: 'In Plant Map',
  //         layout: ['header', 'sidebar'],
  //                       link: '/in-plant/map',
  //         path: '/in-plant/map',
  //         subType: 'inplant',
  //                   pageId: 'inplantMap'
  //                 },
  //               {
  //         authenticated: true,
  //         bLabel: '',
  //               children: undefined,
  //             exact: true,
  //             key: 'inPlantTripDetails',
  //         label: '',
  //         layout: ['header', 'sidebar'],
  //         link: '/in-plant/trips',
  //         path: '/in-plant/trips/:id',
  //                       subType: 'inplant',
  //         pageId: 'inPlantTripDetails'
  //       },
  //                 {
  //                   authenticated: true,
  //                 bLabel: '',
  //         children: undefined,
  //         exact: true,
  //               key: 'inplantDetails',
  //             label: '',
  //             layout: ['header', 'sidebar'],
  //         link: '/in-plant',
  //         path: '/in-plant/:plant',
  //         subType: 'inplant',
  //         pageId: 'inplantDetails'
  //                     },
  //       {
  //         authenticated: false,
  //                 bLabel: '',
  //                 children: undefined,
  //               exact: true,
  //         key: 'inplantTripDetailsShare',
  //         label: '',
  //             layout: [],
  //           link: '/share/in-plant/trips',
  //           path: '/share/in-plant/trips/:id',
  //         subType: 'inplant',
  //         pageId: 'inplantTripDetailsShare'
  //                     }
  //                 ],
  //                 exact: true,
  //     key: 'inplant',
  //     label: 'In Plant',
  //             layout: ['header', 'sidebar'],
  //           link: '/in-plant',
  //         path: '/in-plant'
  //   },
  //   {
  //       authenticated: true,
  //     bLabel: 'InTransit',
  //     children: [
  //       {
  //         authenticated: true,
  //                     bLabel: 'InTransit Performance',
  //                   children: undefined,
  //                   exact: true,
  //         key: 'intransitPerformance',
  //         label: 'InTransit Performance',
  //               layout: ['header', 'sidebar'],
  //               link: '/in-transit',
  //             path: '/in-transit',
  //         subType: 'intransit',
  //         pageId: 'intransitPerformance'
  //       },
  //                     {
  //                     authenticated: true,
  //         bLabel: 'Transporters',
  //         children: undefined,
  //                   exact: true,
  //                 key: 'intransitTransporterPerformance',
  //                 label: '',
  //         layout: ['header', 'sidebar'],
  //         link: '/in-transit/transporters',
  //             path: '/in-transit/transporters',
  //             subType: 'intransit',
  //           pageId: 'intransitTransporterPerformance'
  //       },
  //       {
  //         authenticated: true,
  //                       bLabel: 'Transporters Performance',
  //                     children: undefined,
  //         exact: true,
  //         key: 'transporterDetails',
  //                   label: '',
  //                 layout: ['header', 'sidebar'],
  //                 link: '/in-transit/transporters',
  //         path: '/in-transit/transporters/:transporter',
  //         subType: 'intransit',
  //             pageId: 'transporterDetails'
  //           },
  //         {
  //         authenticated: true,
  //         bLabel: 'E. T. A',
  //         children: undefined,
  //                       exact: true,
  //                     key: 'eta',
  //         label: 'E. T. A',
  //         layout: ['header', 'sidebar'],
  //                 link: '/in-transit/eta',
  //               path: '/in-transit/eta',
  //               subType: 'intransit',
  //         pageId: 'eta'
  //       },
  //         {
  //           authenticated: true,
  //         bLabel: 'InTransit Map',
  //         children: undefined,
  //         exact: true,
  //                     key: 'intransitMap',
  //                     label: 'InTransit Map',
  //                   layout: ['header', 'sidebar'],
  //         link: '/in-transit/map',
  //         path: '/in-transit/map',
  //         subType: 'intransit',
  //               pageId: 'intransitMap'
  //           },
  //           {
  //         authenticated: true,
  //         bLabel: 'Transporters',
  //         children: undefined,
  //         exact: true,
  //                       key: 'allTrips',
  //         label: '',
  //         layout: ['header', 'sidebar'],
  //                   link: '/in-transit/trips',
  //                   path: '/in-transit/trips',
  //                 subType: 'intransit',
  //         pageId: 'allTrips'
  //       },
  //             {
  //             authenticated: true,
  //           bLabel: '',
  //         children: undefined,
  //         exact: true,
  //                       key: 'intransitTripDetails',
  //                     label: '',
  //                     layout: ['header', 'sidebar'],
  //         link: '/in-transit/trips',
  //         path: '/in-transit/trips/:id',
  //                 subType: 'intransit',
  //                 pageId: 'intransitTripDetails'
  //             },
  //       {
  //         authenticated: true,
  //             bLabel: 'InTransit',
  //           children: undefined,
  //           exact: true,
  //         key: 'intransitRouteDetails',
  //         label: '',
  //                       layout: ['header', 'sidebar'],
  //                     link: '/in-transit',
  //                     path: '/in-transit/:id',
  //         subType: 'intransit',
  //         pageId: 'intransitRouteDetails'
  //               },
  //               {
  //               authenticated: false,
  //         bLabel: '',
  //         children: undefined,
  //             exact: true,
  //           key: 'intransitTripDetailsShare',
  //           label: '',
  //         layout: [],
  //         link: '/share/in-transit/trips',
  //         path: '/share/in-transit/trips/:id',
  //         subType: 'intransit',
  //         pageId: 'intransitMap'
  //       }
  //     ],
  //     exact: true,
  //     key: 'multiModelListing',
  //     label: 'Intransit Visibility',
  //     layout: ['header', 'sidebar'],
  //     link: '/',
  //     path: '/'
  //   },
  //   {
  //     authenticated: true,
  //     bLabel: 'Multi Modal',
  //     children: undefined,
  //     exact: true,
  //     key: 'packageHistory',
  //     label: '',
  //     layout: ['header', 'sidebar'],
  //     link: '/packages/:slug',
  //     path: '/packages/:slug'
  //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Home',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'overview',
  //   //     label: 'Home',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/',
  //   //     path: '/'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'KPI Playground',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'kpiConfigure',
  //   //     label: '',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/kpi/editor',
  //   //     path: '/kpi/editor'
  //   //   },
  //   {
  //     authenticated: true,
  //     bLabel: 'Multi Model',
  //     children: undefined,
  //     exact: true,
  //     key: 'shipmentHistory',
  //     label: '',
  //     layout: ['header', 'sidebar'],
  //     link: '/shipment/:slug',
  //     path: '/shipment/:slug'
  //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Home',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'overview',
  //   //     label: 'Home',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/',
  //   //     path: '/'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'KPI Playground',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'kpiConfigure',
  //   //     label: '',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/kpi/editor',
  //   //     path: '/kpi/editor'
  //   //   },
  //   {
  //     authenticated: true,
  //     bLabel: 'KPI',
  //     children: undefined,
  //     exact: true,
  //     key: 'multiModalKpi',
  //     label: 'KPI',
  //     layout: ['header', 'sidebar'],
  //     link: '/kpi',
  //     path: '/kpi'
  //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'In Plant Performance',
  //   //     children: [
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'In Plant path',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'inplantPerformance',
  //   //         label: 'In Plant Performance',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-plant',
  //   //         path: '/in-plant',
  //   //         subType: 'inplant',
  //   //         pageId: 'inplantPerformance'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'In Plant Map',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'inplantMap',
  //   //         label: 'In Plant Map',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-plant/map',
  //   //         path: '/in-plant/map',
  //   //         subType: 'inplant',
  //   //         pageId: 'inplantMap'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: '',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'inPlantTripDetails',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-plant/trips',
  //   //         path: '/in-plant/trips/:id',
  //   //         subType: 'inplant',
  //   //         pageId: 'inPlantTripDetails'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: '',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'inplantDetails',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-plant',
  //   //         path: '/in-plant/:plant',
  //   //         subType: 'inplant',
  //   //         pageId: 'inplantDetails'
  //   //       },
  //   //       {
  //   //         authenticated: false,
  //   //         bLabel: '',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'inplantTripDetailsShare',
  //   //         label: '',
  //   //         layout: [],
  //   //         link: '/share/in-plant/trips',
  //   //         path: '/share/in-plant/trips/:id',
  //   //         subType: 'inplant',
  //   //         pageId: 'inplantTripDetailsShare'
  //   //       }
  //   //     ],
  //   //     exact: true,
  //   //     key: 'inplant',
  //   //     label: 'In Plant',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/in-plant',
  //   //     path: '/in-plant'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'InTransit',
  //   //     children: [
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'InTransit Performance',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitPerformance',
  //   //         label: 'InTransit Performance',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit',
  //   //         path: '/in-transit',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitPerformance'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Transporters',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitTransporterPerformance',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/transporters',
  //   //         path: '/in-transit/transporters',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitTransporterPerformance'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Transporters Performance',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'transporterDetails',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/transporters',
  //   //         path: '/in-transit/transporters/:transporter',
  //   //         subType: 'intransit',
  //   //         pageId: 'transporterDetails'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'E. T. A',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'eta',
  //   //         label: 'E. T. A',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/eta',
  //   //         path: '/in-transit/eta',
  //   //         subType: 'intransit',
  //   //         pageId: 'eta'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'InTransit Map',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitMap',
  //   //         label: 'InTransit Map',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/map',
  //   //         path: '/in-transit/map',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitMap'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'InTransit Trips',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'allTrips',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/trips',
  //   //         path: '/in-transit/trips',
  //   //         subType: 'intransit',
  //   //         pageId: 'allTrips'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: '',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitTripDetails',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/trips',
  //   //         path: '/in-transit/trips/:id',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitTripDetails'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'InTransit',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitRouteDetails',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit',
  //   //         path: '/in-transit/:id',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitRouteDetails'
  //   //       },
  //   //       {
  //   //         authenticated: false,
  //   //         bLabel: '',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitTripDetailsShare',
  //   //         label: '',
  //   //         layout: [],
  //   //         link: '/share/in-transit/trips',
  //   //         path: '/share/in-transit/trips/:id',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitTripDetailsShare'
  //   //       }
  //   //     ],
  //   //     exact: false,
  //   //     key: 'intransit',
  //   //     label: 'InTransit',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/in-transit',
  //   //     path: '/in-transit'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Indent',
  //   //     children: [
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Dashboard',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'indentDashboard',
  //   //         label: 'Dashboard',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/indent/dashboard',
  //   //         path: '/indent/dashboard',
  //   //         subType: 'indentKpi'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Indent List',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'indentList',
  //   //         label: 'Indent List',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/indent',
  //   //         path: '/indent',
  //   //         subType: 'indent',
  //   //         pageId: 'indentList'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Vehicle List',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'indentVehicleList',
  //   //         label: 'Vehicle List',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/indent/vehicle',
  //   //         path: '/indent/vehicle',
  //   //         subType: 'indent',
  //   //         pageId: 'indentVehicleList'
  //   //       }
  //   //     ],
  //   //     exact: false,
  //   //     key: 'indent',
  //   //     label: 'Indent',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/indent',
  //   //     path: '/indent'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Pending Orders',
  //   //     children: [
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Pending Orders',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'allocationList',
  //   //         label: 'Pending Orders',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/pending',
  //   //         path: '/pending',
  //   //         subType: 'allocation',
  //   //         pageId: 'allocationList'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Transporters Allocated',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'transportersAllocated',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/pending/allocate',
  //   //         path: '/pending/allocate',
  //   //         subType: 'allocation',
  //   //         pageId: 'transportersAllocated'
  //   //       }
  //   //     ],
  //   //     exact: false,
  //   //     key: 'allocation',
  //   //     label: 'Allocation',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/pending',
  //   //     path: '/pending'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Poi',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'poi',
  //   //     label: 'Poi',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/poi',
  //   //     path: '/poi',
  //   //     subType: 'poi',
  //   //     pageId: 'poi'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Nearby',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'nearby',
  //   //     label: 'Nearby',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/nearby',
  //   //     path: '/nearby',
  //   //     subType: 'nearBy'
  //   //   },

  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Ideal Routes',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'idealRoutes',
  //   //     label: 'Ideal Routes',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/ideal-routes',
  //   //     path: '/ideal-routes',
  //   //     subType: 'idealRoutes'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Stoppage Analysis',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'stoppageAnalysis',
  //   //     label: 'Stoppage Analysis',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/stoppage-analysis',
  //   //     path: '/stoppage-analysis',
  //   //     subType: 'stoppageAnalysis'
  //   //   },
  //   {
  //     authenticated: true,
  //     bLabel: 'Ocean Stats',
  //     children: undefined,
  //     exact: true,
  //     key: 'oceanStats',
  //     label: 'Ocean Stats',
  //     layout: ['header', 'sidebar'],
  //     link: '/ocean-stats',
  //     path: '/ocean-stats'
  //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'In Plant Performance',
  //   //     children: [
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'In Plant path',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'inplantPerformance',
  //   //         label: 'In Plant Performance',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-plant',
  //   //         path: '/in-plant',
  //   //         subType: 'inplant',
  //   //         pageId: 'inplantPerformance'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'In Plant Map',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'inplantMap',
  //   //         label: 'In Plant Map',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-plant/map',
  //   //         path: '/in-plant/map',
  //   //         subType: 'inplant',
  //   //         pageId: 'inplantMap'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: '',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'inPlantTripDetails',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-plant/trips',
  //   //         path: '/in-plant/trips/:id',
  //   //         subType: 'inplant',
  //   //         pageId: 'inPlantTripDetails'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: '',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'inplantDetails',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-plant',
  //   //         path: '/in-plant/:plant',
  //   //         subType: 'inplant',
  //   //         pageId: 'inplantDetails'
  //   //       },
  //   //       {
  //   //         authenticated: false,
  //   //         bLabel: '',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'inplantTripDetailsShare',
  //   //         label: '',
  //   //         layout: [],
  //   //         link: '/share/in-plant/trips',
  //   //         path: '/share/in-plant/trips/:id',
  //   //         subType: 'inplant',
  //   //         pageId: 'inplantTripDetailsShare'
  //   //       }
  //   //     ],
  //   //     exact: true,
  //   //     key: 'inplant',
  //   //     label: 'In Plant',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/in-plant',
  //   //     path: '/in-plant'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'InTransit',
  //   //     children: [
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'InTransit Performance',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitPerformance',
  //   //         label: 'InTransit Performance',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit',
  //   //         path: '/in-transit',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitPerformance'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Transporters',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitTransporterPerformance',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/transporters',
  //   //         path: '/in-transit/transporters',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitTransporterPerformance'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Transporters Performance',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'transporterDetails',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/transporters',
  //   //         path: '/in-transit/transporters/:transporter',
  //   //         subType: 'intransit',
  //   //         pageId: 'transporterDetails'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'E. T. A',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'eta',
  //   //         label: 'E. T. A',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/eta',
  //   //         path: '/in-transit/eta',
  //   //         subType: 'intransit',
  //   //         pageId: 'eta'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'InTransit Map',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitMap',
  //   //         label: 'InTransit Map',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/map',
  //   //         path: '/in-transit/map',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitMap'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'InTransit Trips',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'allTrips',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/trips',
  //   //         path: '/in-transit/trips',
  //   //         subType: 'intransit',
  //   //         pageId: 'allTrips'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: '',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitTripDetails',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit/trips',
  //   //         path: '/in-transit/trips/:id',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitTripDetails'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'InTransit',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitRouteDetails',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/in-transit',
  //   //         path: '/in-transit/:id',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitRouteDetails'
  //   //       },
  //   //       {
  //   //         authenticated: false,
  //   //         bLabel: '',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'intransitTripDetailsShare',
  //   //         label: '',
  //   //         layout: [],
  //   //         link: '/share/in-transit/trips',
  //   //         path: '/share/in-transit/trips/:id',
  //   //         subType: 'intransit',
  //   //         pageId: 'intransitTripDetailsShare'
  //   //       }
  //   //     ],
  //   //     exact: false,
  //   //     key: 'intransit',
  //   //     label: 'InTransit',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/in-transit',
  //   //     path: '/in-transit'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Indent',
  //   //     children: [
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Dashboard',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'indentDashboard',
  //   //         label: 'Dashboard',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/indent/dashboard',
  //   //         path: '/indent/dashboard',
  //   //         subType: 'indentKpi'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Indent List',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'indentList',
  //   //         label: 'Indent List',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/indent',
  //   //         path: '/indent',
  //   //         subType: 'indent',
  //   //         pageId: 'indentList'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Vehicle List',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'indentVehicleList',
  //   //         label: 'Vehicle List',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/indent/vehicle',
  //   //         path: '/indent/vehicle',
  //   //         subType: 'indent',
  //   //         pageId: 'indentVehicleList'
  //   //       }
  //   //     ],
  //   //     exact: false,
  //   //     key: 'indent',
  //   //     label: 'Indent',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/indent',
  //   //     path: '/indent'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Pending Orders',
  //   //     children: [
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Pending Orders',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'allocationList',
  //   //         label: 'Pending Orders',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/pending',
  //   //         path: '/pending',
  //   //         subType: 'allocation',
  //   //         pageId: 'allocationList'
  //   //       },
  //   //       {
  //   //         authenticated: true,
  //   //         bLabel: 'Transporters Allocated',
  //   //         children: undefined,
  //   //         exact: true,
  //   //         key: 'transportersAllocated',
  //   //         label: '',
  //   //         layout: ['header', 'sidebar'],
  //   //         link: '/pending/allocate',
  //   //         path: '/pending/allocate',
  //   //         subType: 'allocation',
  //   //         pageId: 'transportersAllocated'
  //   //       }
  //   //     ],
  //   //     exact: false,
  //   //     key: 'allocation',
  //   //     label: 'Allocation',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/pending',
  //   //     path: '/pending'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Poi',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'poi',
  //   //     label: 'Poi',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/poi',
  //   //     path: '/poi',
  //   //     subType: 'poi',
  //   //     pageId: 'poi'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Nearby',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'nearby',
  //   //     label: 'Nearby',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/nearby',
  //   //     path: '/nearby',
  //   //     subType: 'nearBy'
  //   //   },

  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Ideal Routes',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'idealRoutes',
  //   //     label: 'Ideal Routes',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/ideal-routes',
  //   //     path: '/ideal-routes',
  //   //     subType: 'idealRoutes'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Stoppage Analysis',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'stoppageAnalysis',
  //   //     label: 'Stoppage Analysis',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/stoppage-analysis',
  //   //     path: '/stoppage-analysis',
  //   //     subType: 'stoppageAnalysis'
  //   //   },
  {
    authenticated: true,
    bLabel: 'Alert',
    children: [
      {
        authenticated: true,
        bLabel: 'Configure Alert',
        children: undefined,
        exact: true,
        key: 'alertSettings',
        layout: ['header', 'sidebar'],
        label: 'Configure Alert',
        link: '/alert',
        path: '/alert',
        subType: 'parcelAlerts',
        pageId: 'alertSetting'
      },
      {
        authenticated: true,
        bLabel: 'Alert Report',
        children: undefined,
        exact: true,
        key: 'alertReport',
        layout: ['header', 'sidebar'],
        label: 'Alert Report',
        link: '/alert/report',
        path: '/alert/report',
        subType: 'parcelAlerts',
        pageId: 'alertSetting'
      }
    ],
    exact: false,
    key: 'alert',
    label: 'Alert',
    layout: ['header', 'sidebar'],
    link: '/alert',
    path: '/alert'
  },
  {
    authenticated: true,
    bLabel: 'Device',
    children: [
      {
        authenticated: true,
        bLabel: 'Devices',
        children: undefined,
        exact: true,
        key: 'devicePortal',
        layout: ['header', 'sidebar'],
        label: 'Device',
        link: '/devicePortal',
        path: '/devicePortal',
        subType: 'devicePortal',
        pageId: 'devicePortal'
      }
    ],
    exact: false,
    key: 'devicePortal',
    label: 'Device Portal',
    layout: ['header', 'sidebar'],
    link: '/devicePortal',
    path: '/devicePortal'
  }
  //   {
  //     authenticated: false,
  //     bLabel: '',
  //     children: undefined,
  //     exact: true,
  //     key: 'packageHistoryShare',
  //     label: '',
  //     layout: [],
  //     link: '/share/packages/',
  //     path: '/share/packages/:slug',
  //     subType: 'intransit',
  //     pageId: 'pacakageHistoryShare'
  //   },
  //   {
  //     authenticated: false,
  //     bLabel: '',
  //     children: undefined,
  //     exact: true,
  //     key: 'shipmentHistoryShare',
  //     label: '',
  //     layout: [],
  //     link: '/share/shipment/',
  //     path: '/share/shipment/:slug',
  //     subType: 'intransit',
  //     pageId: 'shipmentHistoryShare'
  //   }

  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'Settings',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'settings',
  //   //     label: 'Settings',
  //   //     layout: ['header', 'sidebar'],
  //   //     link: '/settings',
  //   //     path: '/settings'
  //   //   },
  //   //   {
  //   //     authenticated: true,
  //   //     bLabel: 'User Management',
  //   //     children: undefined,
  //   //     exact: true,
  //   //     key: 'childUserFilter',
  //   //     layout: ['header', 'sidebar'],
  //   //     label: '',
  //   //     link: '/settings/user-management',
  //   //     path: '/settings/user-management'
  //   //   }
]
export const shareTripRoutes = [
  {
    authenticated: false,
    bLabel: '',
    children: undefined,
    config: TripDetailsRenderingConfig.inTransitShare,
    component: TripDetails,
    exact: true,
    key: 'intransitTripDetailsShare',
    label: '',
    layout: [],
    link: '/share/in-transit/trips',
    path: '/share/in-transit/trips/:id',
    subType: 'intransit',
    pageId: 'intransitTripDetailsShare'
  },
  {
    authenticated: false,
    bLabel: '',
    children: undefined,
    config: parcelConfig,
    component: ParcelDetails,
    exact: true,
    key: 'parcelDetailsShare',
    label: '',
    layout: [],
    link: '/share/track-parcel',
    path: '/share/track-parcel/:slug',
    subType: 'parcel',
    pageId: 'parcelDetailsShare'
  },
  {
    authenticated: false,
    bLabel: '',
    children: undefined,
    component: MultiModelHistory,
    config: {},
    exact: true,
    key: 'shipmentHistoryShare',
    label: '',
    layout: [],
    link: '/share/shipment',
    path: '/share/shipment/:slug',
    subType: 'intransit',
    pageId: 'shipmentHistoryShare'
  },
  {
    authenticated: false,
    bLabel: '',
    children: undefined,
    component: MultiModelHistory,
    config: {},
    exact: true,
    key: 'packageHistoryShare',
    label: '',
    layout: [],
    link: '/share/packages',
    path: '/share/packages/:slug',
    subType: 'intransit',
    pageId: 'packageHistoryShare'
  },
  {
    authenticated: false,
    bLabel: '',
    children: undefined,
    component: ParcelDetails,
    config: parcelConfig,
    exact: true,
    key: 'parcelDetailsShare',
    label: '',
    layout: [],
    link: '/share/parcel',
    path: '/share/parcel/:slug',
    subType: 'parcel',
    pageId: 'parcelDetailsShare'
  },
  {
    authenticated: false,
    bLabel: '',
    children: undefined,
    exact: true,
    config: TripDetailsRenderingConfig.inPlantShare,
    component: TripDetails,
    key: 'inplantTripDetailsShare',
    label: '',
    layout: [],
    link: '/share/in-plant/trips',
    path: '/share/in-plant/trips/:id',
    subType: 'inplant',
    pageId: 'inplantTripDetailsShare'
  },
  {
    authenticated: false,
    bLabel: 'Public Terminal View',
    children: undefined,
    exact: true,
    config: {},
    component: PublicTerminalView,
    key: 'publicTerminalView',
    label: 'Public Terminal View',
    link: '/terminal-view',
    path: '/terminal-view',
    subType: '',
    pageId: ''
  }
]
export const mustHaveRoutes = [
  {
    authenticated: true,
    bLabel: 'Config Management',
    children: undefined,
    exact: true,
    config: {},
    component: ConfigManagement,
    key: 'configManagement',
    label: '',
    layout: ['header', 'sidebar'],
    link: '/settings/config-management',
    path: '/settings/config-management',
    subType: '',
    pageId: ''
  },
  {
    authenticated: true,
    bLabel: 'Reports Config',
    children: undefined,
    exact: true,
    config: {},
    component: ReportsConfiguration,
    key: 'reportsConfigManagement',
    label: '',
    layout: ['header', 'sidebar'],
    link: '/settings/reports-config',
    path: '/settings/reports-config',
    subType: '',
    pageId: ''
  },
  {
    authenticated: true,
    bLabel: 'Tables Config',
    children: undefined,
    exact: true,
    config: {},
    component: TablesConfiguration,
    key: 'tablesConfigManagement',
    label: '',
    layout: ['header', 'sidebar'],
    link: '/settings/tables-config',
    path: '/settings/tables-config',
    subType: '',
    pageId: ''
  },
  {
    authenticated: true,
    bLabel: 'Port Congestion',
    children: undefined,
    exact: true,
    config: {},
    component: InTransitMapPort,
    key: 'portCongestionMap',
    label: '',
    layout: ['header', 'sidebar'],
    link: '/ports',
    path: '/ports',
    subType: '',
    pageId: ''
  },
  {
    authenticated: true,
    bLabel: 'Consigner Onboarding',
    children: undefined,
    exact: true,
    config: ConsignerOnboardRenderingConfig,
    component: ConsignerOnboarding,
    key: 'consignerOnboarding',
    label: '',
    layout: ['header', 'sidebar'],
    link: '/settings/consignment-onboarding',
    path: '/settings/consignment-onboarding',
    subType: '',
    pageId: ''
  },

  {
    authenticated: true,
    bLabel: 'Poi Config',
    children: undefined,
    exact: true,
    config: {},
    component: PoiConfig,
    key: 'poiConfig',
    label: '',
    layout: ['header', 'sidebar'],
    link: '/settings/poi-config/:userId',
    path: '/settings/poi-config/:userId',
    subType: '',
    pageId: ''
  },
  {
    authenticated: true,
    bLabel: 'Default Poi Config',
    children: undefined,
    exact: true,
    config: {},
    component: DefaultPoiConfig,
    key: 'poiConfig',
    label: '',
    layout: ['header', 'sidebar'],
    link: '/settings/default-poi-config/:userId',
    path: '/settings/default-poi-config/:userId',
    subType: '',
    pageId: ''
  }
  ,
  {
    authenticated: true,
    bLabel: 'Child Users',
    children: undefined,
    exact: true,
    config: {},
    component: ChildUsers,
    key: 'childUsers',
    label: '',
    layout: ['header', 'sidebar'],
    link: '/settings/child-users/:userId',
    path: '/settings/child-users/:userId',
    subType: '',
    pageId: ''
  }
  // {
  //   authenticated: true,
  //   bLabel: 'Device',
  //   children:undefined,
  //   exact: true,
  //   config: {},
  //   component: Devices,
  //   key: 'devicePortal',
  //   label: 'Device Portal',
  //   layout: ['header', 'sidebar'],
  //   link: '/devicePortal',
  //   path: '/devicePortal',
  //   subType: '',
  //   pageId: ''
  // }
]
